// extracted by mini-css-extract-plugin
module.exports = {"Container":"About_Container__ssyHt"};